import { isPlatformBrowser } from "@angular/common";
import { OnInit, } from "@angular/core";
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
var CartComponent = /** @class */ (function () {
    function CartComponent(platformId, app, router, rest, formDataService, countIncart, seo, _lightbox, config, modalService, localStorage) {
        this.platformId = platformId;
        this.app = app;
        this.router = router;
        this.rest = rest;
        this.formDataService = formDataService;
        this.countIncart = countIncart;
        this.seo = seo;
        this._lightbox = _lightbox;
        this.modalService = modalService;
        this.localStorage = localStorage;
        this.node_static_url = environment.node_static_url;
        this.invoice_id = 0;
        this.total = 0;
        this.countTotal = 0;
        this.isEmptyCart = false;
        this.timeLeft = 0;
        this.isCheckOut = false;
        this.proofileCol = false;
        this._albumsPhoto = [];
        this._albumsPassport = [];
        this._albumsCover = [];
        this._albumProoFile = [];
        this.data = {
            session_id: "",
            input_id: "",
            input_value: "",
        };
        this.seo.addMetaTags();
        config.backdrop = "static";
        config.keyboard = false;
    }
    CartComponent.prototype.ngOnInit = function () {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.person = this.formDataService.getFormData();
        var authInfo = null;
        try {
            var localAuth = localStorage.getItem(environment.localAuthenInfo);
            if (localAuth && localAuth !== "null" && localAuth !== "undefined") {
                authInfo = JSON.parse(localAuth);
            }
        }
        catch (e) {
            console.warn("Failed to parse localAuthenInfo in cart:", e);
        }
        if (authInfo && authInfo.token) {
            this.person.token = authInfo.token;
            this.getData();
            this.selected_payment_method = "";
            this.selected_payment_method_text = "";
            this.selected_payment_active = "";
        }
        else {
            this.router.navigate(["/apply"]);
        }
    };
    CartComponent.prototype.getData = function () {
        this.person.currentActiveForm = "3";
        this.countIncart.funcCountCart();
        this.getPersonInfo();
    };
    CartComponent.prototype.addMorePerson = function () {
        this.formData = this.formDataService.resetFormData();
        this.router.navigate(["/application"]);
        this.data.session_id = this.localStorage.getItem("session_id");
        this.data.input_id = "addMorePeople";
        this.data.input_value = "add_more_people";
        // this.rest.updateUserSession(this.data).subscribe((res) => {
        //   console.log("Result Update Session when focus input:", res);
        // });
    };
    CartComponent.prototype.getPaymentMethods = function () {
        var _this = this;
        this.rest.getPaymentMethods().subscribe(function (result) {
            _this.mPaymentMethod = result;
        });
    };
    CartComponent.prototype.calculateTotal = function () {
        this.countTotal = this.mDataArrayPerson.length;
    };
    CartComponent.prototype.testPay = function () {
        var payment = {
            invoice_id: 3155,
            payment_method: "cbs",
            pay_from: null,
        };
        console.log({ payment: payment });
    };
    CartComponent.prototype.proceedContinue = function (e) {
        this.data.session_id = this.localStorage.getItem("session_id");
        this.data.input_id = e.target.id;
        this.data.input_value = "to_payment_review";
        // this.rest.updateUserSession(this.data).subscribe((res) => {
        //   console.log("Result Update Session when focus input:", res);
        // });
        this.router.navigate(["/continue-review"]);
    };
    CartComponent.prototype.deletePerson = function (index, application_id, first_name) {
        var _this = this;
        this.data.session_id = this.localStorage.getItem("session_id");
        this.data.input_id = "deletePerson";
        this.data.input_value = "delete_person";
        // this.rest.updateUserSession(this.data).subscribe((res) => {
        //   console.log("Result Update Session when focus input:", res);
        // });
        Swal.fire({
            title: "Are you sure?",
            text: "Are you sure to remove " + first_name + " ?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            cancelButtonText: "Cancel",
            confirmButtonText: "Remove",
        }).then(function (result) {
            if (result.value) {
                _this.rest.deletePerson(application_id).subscribe(function (rs) {
                    if (rs.status == "error") {
                        _this.isCheckOut = true;
                        _this.getPersonInfo();
                        _this.countIncart.funcCountCart();
                        return Swal.fire({
                            type: "error",
                            title: "" + rs.message,
                            showConfirmButton: true,
                        });
                    }
                    else {
                        _this.calculateTotal();
                        _this._albumsPhoto.splice(index, 1);
                        _this._albumsPassport.splice(index, 1);
                        if (rs.status == "success") {
                            _this.getPersonInfo();
                            _this.countIncart.funcCountCart();
                        }
                    }
                });
            }
        });
    };
    CartComponent.prototype.open = function (content) {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.startTimer();
        this.modalService.open(content, { centered: true });
    };
    CartComponent.prototype.openPhoto = function (index) {
        if (isPlatformBrowser(this.platformId)) {
            this._lightbox.open(this._albumsPhoto, index, { centerVertically: true });
        }
    };
    CartComponent.prototype.openPassport = function (index) {
        if (isPlatformBrowser(this.platformId)) {
            this._lightbox.open(this._albumsPassport, index, {
                centerVertically: true,
            });
        }
    };
    CartComponent.prototype.openProoFile = function (idx) {
        console.log(idx);
        if (isPlatformBrowser(this.platformId)) {
            this._lightbox.open(this._albumProoFile, idx, {
                centerVertically: true,
            });
        }
    };
    CartComponent.prototype.openCover = function (index) {
        if (isPlatformBrowser(this.platformId)) {
            this._lightbox.open(this._albumsCover, index, { centerVertically: true });
        }
    };
    CartComponent.prototype.closeImgPreview = function () {
        this._lightbox.close();
    };
    CartComponent.prototype.startTimer = function () {
        var _this = this;
        this.interval = setInterval(function () {
            _this.timeLeft += 20;
            if (_this.timeLeft === 100) {
                clearInterval(_this.interval);
                _this.modalService.dismissAll();
                _this.getPersonInfo();
                _this.countIncart.funcCountCart();
            }
        }, 1000);
    };
    CartComponent.prototype.getPersonInfo = function () {
        var _this = this;
        this.rest.getPersonForPayment().subscribe(function (result) {
            if (result.length > 0) {
                _this.mDataArrayPerson = result;
                _this.calculateTotal();
                _this.invoice_id = result[0].invoice_id;
                var m_total = 0;
                for (var i = 0; i < result.length; i++) {
                    m_total += result[i].price;
                }
                _this.total = Math.round(m_total * 100) / 100 || 0;
            }
            else {
                _this.mDataArrayPerson = result;
                _this.isEmptyCart = true;
                _this.total = 0;
            }
            _this.onLoadImage(result);
        });
    };
    CartComponent.prototype.onLoadImage = function (person) {
        var _this = this;
        var _loop_1 = function (i) {
            if (person[i].version == "2") {
                this_1.rest.getBase64ImageService(person[i].photo_name, "photo").subscribe(function (result) {
                    _this._albumsPhoto.push({
                        src: result["photo_name"],
                        caption: "Photo "
                    });
                    _this.mDataArrayPerson[i].photo_name = result["photo_name"];
                });
                this_1.rest.getBase64ImageService(person[i].passport_name, "passport").subscribe(function (result) {
                    _this._albumsPassport.push({
                        src: result["passport_name"],
                        caption: "Passport "
                    });
                    _this.mDataArrayPerson[i].passport_name = result["passport_name"];
                });
            }
            else {
                this_1.mDataArrayPerson[i].photo_name = person[i].photo_name;
                this_1._albumsPhoto.push({
                    src: person[i].photo_name,
                    caption: "Photo "
                });
                this_1.mDataArrayPerson[i].passport_name = person[i].passport_name;
                this_1._albumsPassport.push({
                    src: person[i].passport_name,
                    caption: "Passport "
                });
            }
        };
        var this_1 = this;
        for (var i = 0; i < person.length; i++) {
            _loop_1(i);
        }
    };
    return CartComponent;
}());
export { CartComponent };
